import { render, staticRenderFns } from "./jd_agent_add.vue?vue&type=template&id=e9ff9624&scoped=true&"
import script from "./jd_agent_add.vue?vue&type=script&lang=js&"
export * from "./jd_agent_add.vue?vue&type=script&lang=js&"
import style0 from "./jd_agent_add.vue?vue&type=style&index=0&id=e9ff9624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ff9624",
  null
  
)

export default component.exports